// extracted by mini-css-extract-plugin
export default {"number":"Number__number___TuoMg"};